import type { Messages } from "./de";

export const it: Messages = {
  common: {
    save: "Salva",
    cancel: "Annulla",
    close: "Chiudi",
    delete: "Elimina",
    edit: "Modifica",
    add: "Aggiungi",
    search: "Cerca",
    loading: "Caricamento …",
    retry: "Riprova",
    yes: "Sì",
    no: "No",
    all: "Tutti",
    today: "Oggi",
    reason: "Motivazione",
    reason_hint: "Viene salvata nel registro.",
    note: "Nota",
    from: "Dal",
    to: "Al",
    date: "Data",
    time: "Ora",
    status: "Stato",
    employee: "Collaboratore",
    employees: "Collaboratori",
    department: "Reparto",
    month: "Mese",
    details: "Dettagli",
    saved: "Salvato",
    not_set: "—",
    optional: "facoltativo",
    minutes_short: "min",
    hours_short: "h",
    open: "Apri",
    previous: "Indietro",
    next: "Avanti",
  },
  nav: {
    section_overview: "Panoramica",
    section_time: "Presenze",
    section_admin: "Amministrazione",
    today: "Oggi",
    employees: "Collaboratori",
    times: "Timbrature",
    accounts: "Banca ore",
    absences: "Assenze",
    payroll: "Chiusura mese",
    settings: "Impostazioni",
    my_app: "App collaboratori",
    search: "Cerca …",
    search_placeholder: "Cerca collaboratore o pagina",
    no_results: "Nessun risultato",
    pages: "Pagine",
    theme: "Aspetto",
    theme_light: "Chiaro",
    theme_dark: "Scuro",
    theme_system: "Sistema",
    language: "Lingua",
  },
  auth: {
    title: "Accedi",
    subtitle: "Rilevazione presenze e pianificazione",
    email: "E-mail",
    password: "Password",
    sign_in: "Accedi",
    send_code: "Invia codice via e-mail",
    code: "Codice dall'e-mail",
    code_sent: "Ti abbiamo inviato un codice di 6 cifre.",
    verify: "Conferma",
    use_password: "Accedi con password",
    use_code: "Accedi con codice via e-mail",
    sign_out: "Esci",
    invalid: "E-mail o password non corretti.",
    invalid_code: "Il codice non è valido o è scaduto.",
    select_tenant: "Scegli azienda",
    select_tenant_hint: "Hai accesso a più aziende. Ogni scheda del browser lavora in un'azienda.",
    no_tenant: "Il tuo account non è ancora assegnato a nessuna azienda. Rivolgiti all'amministrazione.",
  },
  roles: {
    admin: "Amministrazione",
    approver: "Approvazione",
    coordinator: "Coordinamento",
    payroll: "Ufficio paghe",
    employee: "Collaboratore",
  },
  weekdays: { mon: "Lu", tue: "Ma", wed: "Me", thu: "Gi", fri: "Ve", sat: "Sa", sun: "Do" },
  status: {
    present: "Presente",
    break: "In pausa",
    gone: "Uscito",
    not_started: "Non ancora arrivato",
    absent: "Assente",
    day_off: "Libero",
    holiday: "Festivo",
  },
  anomaly: {
    missing_clock_out: "Uscita mancante",
    no_presence: "Nessuna presenza",
    foreign_terminal: "Terminale di altro reparto",
    break_shortfall: "Pausa obbligatoria troppo breve",
    break_report_short: "Segnalata pausa più breve",
    auto_break_applied: "Pausa obbligatoria detratta automaticamente",
    duplicate_ignored: "Timbratura doppia (ignorata)",
    work_on_day_off: "Lavoro in giorno libero",
  },
  punch_status: {
    valid: "Conteggiata",
    duplicate: "Doppia",
    rejected_foreign_terminal: "Altro reparto",
    voided: "Annullata",
  },
  absence_type: {
    ferie: "Ferie",
    permessi: "Permessi",
    rol: "ROL",
    sick: "Malattia",
    injury: "Infortunio",
    parental: "Congedo parentale",
    training: "Formazione",
    other: "Altro",
  },
  today: {
    eyebrow: "Oggi",
    title: "Chi c'è?",
    description: "In tempo reale dalle timbrature di tutti i reparti.",
    present: "Presenti",
    missing_break: "Pausa dovuta",
    anomalies: "Anomalie aperte",
    anomalies_hint: "ultimi 31 giorni",
    unassigned: "Badge sconosciuti",
    list_title: "Collaboratori oggi",
    worked: "Lavorato",
    break: "Pausa",
    first_in: "Entrata",
    inbox_title: "Badge da assegnare",
    inbox_hint: "Timbrature di badge non ancora assegnati a un collaboratore.",
    inbox_empty: "Tutti i badge sono assegnati.",
    assign: "Assegna",
    assign_title: "Assegna badge",
    assign_hint: "Tutte le timbrature in attesa di questo badge verranno poi rielaborate automaticamente.",
    taps: "{{count}} timbratura/e",
    reprocessed: "Badge assegnato, {{count}} timbratura/e rielaborate.",
    reader: "Lettore",
  },
  employees: {
    eyebrow: "Anagrafica",
    title: "Collaboratori",
    description: "Reparto, modello orario, badge e accesso all'app collaboratori.",
    new: "Nuovo collaboratore",
    personnel_number: "Matricola",
    first_name: "Nome",
    last_name: "Cognome",
    email: "E-mail",
    entry_date: "Assunzione",
    exit_date: "Cessazione",
    schedule: "Orario",
    schedule_since: "dal {{date}}",
    change_schedule: "Cambia orario",
    valid_from: "Valido dal",
    card: "Badge",
    cards: "Badge",
    card_none: "Nessun badge",
    revoke: "Blocca",
    app_access: "App collaboratori",
    app_active: "Attivo",
    app_none: "Nessun accesso",
    invite: "Invita",
    invited: "Invito inviato",
    has_bonus: "Bonus previsto",
    notes: "Note",
    empty: "Nessun collaboratore ancora inserito.",
    balance: "Banca ore",
    filter_department: "Reparto",
  },
  times: {
    eyebrow: "Presenze",
    title: "Timbrature",
    description: "Giorno per giorno, con pausa obbligatoria, ore previste e differenza. Le correzioni vengono registrate.",
    select_employee: "Scegli collaboratore",
    target: "Previsto",
    worked: "Effettivo",
    break: "Pausa",
    auto_break: "Pausa autom.",
    credit: "Accredito",
    delta: "Differenza",
    punches: "Timbrature",
    intervals: "Blocchi di lavoro",
    add_punch: "Aggiungi timbratura",
    add_punch_hint: "Per timbrature dimenticate. Conta come una timbratura al lettore.",
    void: "Annulla",
    void_title: "Annulla timbratura",
    manual: "Inserita a mano",
    break_report: "Pausa dichiarata",
    break_report_hint: "Pausa effettivamente fatta ma non timbrata. Sostituisce la detrazione automatica.",
    remove_break_report: "Rimuovi dichiarazione",
    acknowledge: "Segna come chiarito",
    acknowledged: "Chiarito",
    no_punches: "Nessuna timbratura",
    day_open: "in corso",
    month_total: "Totale mese",
    empty: "Nessun giorno in questo periodo.",
  },
  absences: {
    eyebrow: "Presenze",
    title: "Assenze",
    description: "Ferie, permessi, ROL, malattia. L'accredito avviene sulle ore previste del giorno. Le richieste arrivano con la fase 2.",
    new: "Registra assenza",
    type: "Tipo",
    period: "Periodo",
    full_day: "Giornata intera",
    minutes_per_day: "Minuti al giorno",
    empty: "Nessuna assenza in questo periodo.",
  },
  accounts: {
    eyebrow: "Presenze",
    title: "Banca ore",
    description: "Saldo fino a ieri: differenze giornaliere più correzioni e liquidazioni.",
    balance: "Saldo",
    adjustment: "Registra correzione",
    adjustment_hint: "Minuti positivi accreditano, negativi addebitano.",
    minutes: "Minuti",
    entries: "Movimenti",
    kind: {
      manual_adjustment: "Correzione",
      overtime_payout: "Liquidazione",
      carry_over: "Riporto",
    },
  },
  payroll: {
    eyebrow: "Paghe",
    title: "Chiusura mese",
    description: "Ore mensili per l'ufficio paghe e straordinari da liquidare.",
    days_worked: "Giorni",
    open_anomalies: "Aperte",
    payout: "Liquidazione",
    balance_end: "Saldo fine mese",
    close: "Chiudi mese",
    close_title: "Chiudi mese {{month}}",
    close_hint: "Dopo, timbrature e correzioni di questo mese sono bloccate.",
    close_blocked: "{{count}} giorno/i con anomalie aperte. Chiarire o chiudere con motivazione.",
    override_reason: "Motivazione per la chiusura nonostante anomalie aperte",
    closed: "Chiuso",
    open: "Aperto",
    reopen: "Riapri",
    reopen_title: "Riapri mese",
    export_hours: "Ore mensili",
    export_overtime: "Straordinari",
    exported: "Esportazione creata: {{file}}",
    payout_title: "Liquida straordinari",
    payout_hint: "Le ore vengono addebitate sulla banca ore all'ultimo del mese e compaiono nell'export straordinari.",
    payout_hours: "Ore",
    month_not_over: "Il mese non è ancora finito.",
  },
  settings: {
    eyebrow: "Amministrazione",
    title: "Impostazioni",
    description: "Regole, orari, reparti, terminali e accessi — tutto configurabile, niente fisso nel codice.",
    tabs: {
      rules: "Regole",
      templates: "Orari",
      departments: "Reparti e terminali",
      unifi: "UniFi Access",
      users: "Utenti",
    },
    rules: {
      valid_from: "Valido dal",
      valid_from_hint: "I giorni precedenti continuano con la versione precedente.",
      breakThresholdMinutes: "Pausa obbligatoria oltre (minuti di lavoro)",
      requiredBreakMinutes: "Durata pausa obbligatoria (minuti)",
      minBreakSegmentMinutes: "Pausa minima conteggiabile (minuti)",
      duplicateWindowSeconds: "Blocco doppia timbratura (secondi)",
      autoBreakDeduction: "Detrarre la pausa obbligatoria mancante a fine giornata",
      capAutoBreakAtThreshold: "Detrazione al massimo fino alla soglia",
      breakReminderTime: "Promemoria pausa alle",
      dayCloseTime: "Chiusura giornata alle",
      history: "Versioni",
      saved: "Regole salvate, {{count}} giorno/i ricalcolati.",
    },
    templates: {
      new: "Nuovo orario",
      name: "Nome",
      description: "Descrizione",
      weekly: "Settimana",
    },
    departments: {
      new: "Nuovo reparto",
      name: "Nome",
      terminals: "Terminali",
      new_terminal: "Nuovo terminale",
      device_id: "ID lettore UniFi",
      location_id: "ID porta UniFi",
      last_event: "Ultima timbratura",
      never: "mai",
    },
    unifi: {
      intro: "Ogni apertura con badge su un lettore UniFi Access viene segnalata a optitime come webhook firmato.",
      webhook_url: "Indirizzo webhook",
      webhook_secret: "Secret webhook",
      api_url: "Indirizzo API (tunnel o port forwarding)",
      api_url_hint: "es. https://unifi-api.azienda.it — porta 12445 del controller, solo HTTPS con certificato valido.",
      api_token: "Token API",
      cf_id: "Cloudflare Access Client-ID",
      cf_secret: "Cloudflare Access Client-Secret",
      stored: "presente",
      missing: "mancante",
      last_webhook: "Ultimo webhook",
      last_api: "Ultimo contatto API",
      last_error: "Ultimo errore",
      test: "Verifica connessione",
      register: "Registra webhook",
      backfill: "Recupera ora",
      devices: "Lettori sul controller",
      users: "Utenti sul controller",
      test_ok: "Connessione attiva, {{count}} dispositivo/i trovati.",
      registered: "Webhook registrato.",
      backfilled: "{{fetched}} evento/i letti, {{processed}} nuovi elaborati.",
      replace_hint: "Lasciare vuoto per mantenere il valore salvato.",
    },
    users: {
      invite: "Invita utente",
      name: "Nome",
      roles: "Ruoli",
      link_employee: "Collega a collaboratore",
      deactivate: "Disattiva",
    },
  },
  me: {
    today: "Oggi",
    week: "Settimana",
    account: "Banca ore",
    settings: "Io",
    clocked_in: "Timbrato",
    clocked_out: "Non timbrato",
    since: "dalle {{time}}",
    worked_today: "Lavorato oggi",
    break_taken: "Pausa fatta",
    break_due: "Pausa obbligatoria ancora da fare: {{minutes}} min",
    break_ok: "Pausa obbligatoria fatta",
    blocks: "Blocchi di oggi",
    balance: "Banca ore",
    balance_hint: "Saldo fino a ieri",
    push_title: "Notifiche",
    push_enable: "Attiva notifiche",
    push_enabled: "Le notifiche sono attive.",
    push_unsupported: "Questo browser non supporta le notifiche.",
    push_ios_hint: "Su iPhone: prima installa tramite „Condividi → Aggiungi alla schermata Home“, poi attiva qui.",
    push_denied: "Le notifiche sono bloccate nel browser.",
    install_hint: "Suggerimento: aggiungi optitime alla schermata Home.",
    no_employee: "Il tuo accesso non è ancora collegato a un collaboratore.",
    requests_soon: "Le richieste (pausa dichiarata, correzione, ferie) arrivano con la fase 2.",
  },
  errors: {
    generic: "Non è andato a buon fine.",
    period_closed: "Il mese è già chiuso.",
    forbidden: "Non hai i permessi necessari.",
    absence_overlap: "In questo periodo esiste già un'assenza.",
    credential_already_assigned: "Questo badge è già assegnato a un collaboratore.",
    employee_already_linked: "Questo collaboratore ha già un accesso.",
    invalid_input: "Controlla i dati inseriti.",
    network_error: "Nessuna connessione al server.",
    future_punch: "Non sono possibili timbrature nel futuro.",
    open_anomalies: "Ci sono ancora anomalie aperte.",
    month_not_over: "Il mese non è ancora finito.",
    request_id: "ID supporto",
  },
};
